import { Storage } from "@aws-amplify/storage";
import { alpha, Avatar, Box, Button, ButtonGroup, Chip, Grid, IconButton, InputAdornment, Menu, MenuItem, Paper, Stack, Switch, TextField, Typography } from "@mui/material";
import useMouse from "@react-hook/mouse-position";
import FeatherIcon from "feather-icons-react";
import React, { useContext, useEffect, useRef, useState } from "react";
import ReactPlayer from "react-player";
import WaveformData from "waveform-data";
import { AppDataContext } from "../../components/context/app-data-context.jsx";
import LegendItemGroup from "../../components/legend-item-group/index.jsx";
import CustomSvgIcons from "../../components/svg-icons/index.jsx";
import { useThemeMode } from "../../components/theme/index.jsx";
import { colours as constColours, CustomTooltip, toggleButtonStyle } from "../../consts.js";
import { THEME_MODES } from "../../helpers/constant.js";
import { removeDetectKeywordFromVisuals } from "../../helpers/index.js";
import Utils from "../../utils";

function useWindowSize() {
  // Initialize state with undefined width/height so server and client renders match
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });

  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Call handler right away so state gets updated with initial window size
    handleResize();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount

  return windowSize;
}
function ConversationTranscript({ conversationId, alertsData }) {
  const size = useWindowSize();
  const AppDataContextDTO = useContext(AppDataContext);

  const [conversation, setConversation] = useState({});
  const [autoscroll, setAutoscroll] = useState(false);
  const [conversationFile, setConversationFile] = useState("");
  const [trackerSet, setTrackerSet] = useState([]);
  const [topicSet, setTopicSet] = useState([]);
  const [agent, setAgent] = useState("Speaker 2");
  const [tsfilter, setTsFilter] = useState("Full");
  const { colours, themeMode } = useThemeMode();
  const scrollContainer = useRef(null);
  const [scrollPosition, setScrollPosition] = useState(0);
    
  async function getConversationData() {
    const conversation = await Utils.genericGet("getConversation", conversationId);

    try {
      // set data for breadcrumb
      AppDataContextDTO.setCampaign({
        id: conversation.data.getConversation.campaign.id,
        name: conversation.data.getConversation.campaign.name
      });
    } catch (error) {

    }

    conversation.data.getConversation.analytics = JSON.parse(
      conversation.data.getConversation.analytics
    );
    conversation.data.getConversation.questions = JSON.parse(
      conversation.data.getConversation.questions
    );
    conversation.data.getConversation.summary = JSON.parse(
      conversation.data.getConversation.summary
    );
    conversation.data.getConversation.topics = JSON.parse(
      conversation.data.getConversation.topics
    );
    conversation.data.getConversation.trackersdetected = JSON.parse(
      conversation.data.getConversation.trackersdetected
    ) || [];

    conversation.data.getConversation.trackersdetected.forEach((t) => {
        if(!t.matches) {
            t.matches = [];
        }
    })

    conversation.data.getConversation.transcript = JSON.parse(
      conversation.data.getConversation.transcript
    );
    setAgent(conversation.data.getConversation.agenttag);
    // console.log({ conversation });
    let newtrackerset = [];
    conversation.data.getConversation.trackersdetected.forEach((z) => {
      z.matches.forEach((a) => {
        a.messageRefs.forEach((b) => {
          newtrackerset.push({
            name: z.name,
            id: b.id,
            alert: alertsData.find((q) => q.name === z.name) ? true : false,
          });
        });
      });
    });

    setTrackerSet(newtrackerset);
    let newtopicset = [];
    try {
        conversation.data.getConversation.topics.topics.forEach((z) => {
            z.messageIds.forEach((a) => {
                newtopicset.push({ name: z.text, id: a });
            });
        });
    } catch (error) {
        console.log("No topic", error)
    }
    setTopicSet(newtopicset);
    setConversation(conversation.data.getConversation);
    setConversationFile(conversation.data.getConversation.name);
  }

  React.useEffect(() => {
    const getConversationHelper = async () => {
        await getConversationData();
    }
    getConversationHelper();
  }, [conversationId]);

  // const size = useWindowSize();
  const [playicon, setPlayicon] = useState(true);
  const [waveformd, setWaveformd] = useState([]);
  const [canvswidth, setCanvswidth] = useState(1000);
  const [tagsMode, setTagsMode] = useState("trackers");
  const [progresswidth, setProgresswitdh] = useState(0);
  const inputEl = useRef(null);
  var canvref = useRef(null);
  var dref = useRef(null);
  // var mouseref = useRef(null);
  const [audioURL, setAudioURL] = useState(null);
  const mouse = useMouse(canvref, {
    enterDelay: 100,
    leaveDelay: 100,
  });
  // useEffect(() => {
  //
  // }, [size]);

  useEffect(() => {
    setCanvswidth(canvref.current.clientWidth);
  }, [canvref]);

  function redraw(cuts, sens) {
    // console.log({sens});
    if (cuts === undefined) cuts = waveformd;
    var canvas = document.getElementById("canvas");
    var ctx = canvas.getContext("2d");
    let barwidth = parseInt(canvref.current.offsetWidth / cuts.length);
    let maxvol = Math.max(...cuts.map((z) => Math.abs(z)));
    // let minvol = Math.min(...cuts.map((z) => Math.abs(z)));
    cuts.forEach((z, zidx) => {
      let scaledy = parseInt((z / maxvol) * 75);
      // console.log(scaledy)
      if (sens[zidx].sen < -0.3) ctx.fillStyle = colours.orange100;
      else if (sens[zidx].sen > 0.3) ctx.fillStyle = colours.green100;
      else ctx.fillStyle = colours.dividergray;
      // if (z > 0) {
      //   if (zidx > 200 && zidx < 250) ctx.fillStyle = colours.dividergray;
      //   else ctx.fillStyle = colours.orange100;
      if (sens[zidx].sp === "Speaker 1") {
        // console.log("s1")
        // console.log(zidx * (barwidth + 1), 75 - Math.abs(scaledy), barwidth, Math.abs(scaledy))
        ctx.fillRect(
          zidx * (barwidth + 1),
          75 - Math.abs(scaledy),
          barwidth,
          Math.abs(scaledy)
        );
      } else {
        // console.log("s2")
        // console.log(zidx * (barwidth + 1), 75, barwidth,Math.abs(scaledy))
        ctx.fillRect(zidx * (barwidth + 1), 75, barwidth, Math.abs(scaledy));
      }
      // } else {
      //   if (zidx > 50 && zidx < 100) ctx.fillStyle = colours.dividergray;
      //   else ctx.fillStyle = colours.green100;
      // }
    });
  }

  async function getFunction() {
    var canvas = document.getElementById("canvas");
    canvas.width = canvref.current.clientWidth;

    const audioContext = new AudioContext();
    let file;
    let ftch;

    try {
      if (conversation.s3Key) {
        console.log("Using SFTP bucket", conversation.s3Key);
        file = await Storage.get(conversation.s3Key, {
          download: false,
          region: process.env.REACT_APP_AWS_USER_FILES_S3_BUCKET_REGION,
          level: 'public', // or 'protected', 'private'
          bucket: process.env.REACT_APP_AWS_USER_FILES_S3_BUCKET_SFTP,
          customPrefix: {
            public: '', // remove 'public/' prefix
          }
        });
      } else {
        file = await Storage.get(conversationFile, {
          download: false,
          region: process.env.REACT_APP_AWS_USER_FILES_S3_BUCKET_REGION,
          level: 'public', // or 'protected', 'private'
          bucket: process.env.REACT_APP_AWS_USER_FILES_S3_BUCKET
        });
      }

      ftch = await fetch(file);

      if (!ftch.ok) {
        throw new Error(
          `Failed to fetch file from S3. Status: ${ftch.status}`
        );
      }
    } catch (error) {
      console.error("Error fetching file from S3:", error);
      return;
    }

    let blb = await ftch.blob();
    // console.log({ blb });

    let newnewurl = URL.createObjectURL(blb);
    setAudioURL(newnewurl);
    let arrbuff = await blb.arrayBuffer();
    async function makewavfrm(arbf) {
      const options = {
        audio_context: audioContext,
        array_buffer: arbf,
        scale: 128,
      };
      return new Promise((resolve, reject) => {
        WaveformData.createFromAudio(options, (err, waveform) => {
          if (err) {
            console.log({ err });
            reject(err);
          } else {
            // console.log({ waveform });
            resolve(waveform);
          }
          audioContext.close();
        });
      });
    }
    let wavefm = await makewavfrm(arrbuff);
    let original = wavefm.toJSON().data;
    let newsample = [];
    const cuts = original.length / 200;
    while (original.length > cuts) {
      let samp = original.splice(0, cuts);
      let sign = newsample.length % 30 < 10 ? 1 : -1;
      newsample.push(sign * Math.max(...samp));
    }
    if (original.length > 0) newsample.push(Math.max(...original));
    WaveformData.create(wavefm.toJSON());

    setWaveformd(newsample);
    if (conversation.transcript.messages) {
      let sent = conversation.transcript.messages.map((z) => {
        return {
          t: (z.endTime) - (z.startTime),
          sen: z.sentiment ? z.sentiment.polarity.score : 0,
          sp: z.from.name,
        };
      });
      let totaltstime = sent.reduce((a, b) => (a = a + b.t), 0);
      let tscuttime = totaltstime / 200;
      let cutter = [];
      while (sent.length > 0) {
        if (sent[0].t > tscuttime) {
          cutter.push({ t: tscuttime, sen: sent[0].sen, sp: sent[0].sp });
          sent[0].t -= tscuttime;
        } else {
          sent[1].t += sent[0].t;
          sent[1].sen = (sent[1].sen + sent[0].sen) / 2;
          sent.shift();
        }
        if (sent.length === 1) {
          cutter.push({ t: tscuttime, sen: sent[0].sen, sp: sent[0].sp });
          sent.shift();
        }
      }
      while (cutter.length < newsample.length)
        cutter.push({ t: tscuttime, sen: 0 });
      while (cutter.length > newsample.length) cutter.pop();
      redraw(newsample, cutter);
    }
  }

  useEffect(() => {
    if(conversationFile) {
        getFunction();
    }
  }, [conversationFile, size, conversation]);

  return (
    <Grid
      ref={scrollContainer}
      className="vocalysed-home-upadted transcript"
      container
      spacing={0}
      direction="row"
      flexGrow={1}
      padding={3}
      gap={3}
      overflow="auto"
      alignItems="start"
      sx={{ overflowX: "hidden" }}
      onScroll={(e) => {
        setScrollPosition(e.target.scrollTop);
      }}
    >
      <Paper
        sx={{ display: "flex", flexDirection: "column", width: '100%', borderRadius: 2.5, boxSizing: "border-box" }}
      >
        <Stack direction="row" flexWrap="wrap" gap={1} justifyContent={{ xs: "center", md: "space-between" }} className="card-piece-updated" sx={{ padding: { xs: '8px 0', md: 3 } }}>
          <ButtonGroup
            variant="contained"
            aria-label="outlined primary button group"
            className="buttons-border-extend"
            style={{ display: "inline-block" }}
          >
            <Button
              style={toggleButtonStyle(tsfilter === "Full", colours, themeMode)}
              onClick={() => setTsFilter("Full")}
            >
              Full
              <Typography variant="body2" component="span" sx={{ display: { xs: 'none', sm: 'inline-block' } }}>
                &nbsp;Transcript
              </Typography>
            </Button>

            <Button
              style={toggleButtonStyle(tsfilter === "Agent", colours, themeMode)}
              onClick={() => setTsFilter("Agent")}
            >
              Agent
              <Typography variant="body2" component="span" sx={{ display: { xs: 'none', sm: 'inline-block' } }}>
                &nbsp;Transcript
              </Typography>
            </Button>

            <Button
              style={toggleButtonStyle(tsfilter === "Client", colours, themeMode)}
              onClick={() => setTsFilter("Client")}
            >
              Client
              <Typography variant="body2" component="span" sx={{ display: { xs: 'none', sm: 'inline-block' } }}>
                &nbsp;Transcript
              </Typography>
            </Button>
          </ButtonGroup>
          <LegendItemGroup
            circleSize={themeMode === THEME_MODES.COLOR_VISION ? 24 : 16}
            items={[
              { label: "Neutral", color: colours.dividergray },
              { label: "Negative", color: colours.critical100, pattern: themeMode === THEME_MODES.COLOR_VISION && CustomSvgIcons.negativePattern },
              { label: "Positive", color: colours.success100, pattern: themeMode === THEME_MODES.COLOR_VISION && CustomSvgIcons.positivePattern },
            ]}
          />

          {true ? null : (
            <TextField
              id="input-with-icon-textfield"
              label="Search"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <FeatherIcon
                      icon="search"
                      style={{ color: colours.black }}
                    />
                  </InputAdornment>
                ),
              }}
              variant="standard"
            />
          )}
        </Stack>
        <Stack direction="row" alignItems="center" className="card-piece-updated" sx={{ px: { xs: 1, md: 3 }, pb: { xs: 1, md: 3 } }}>
          <div
            style={{
              width: "5%",
              margin: "auto",
              textAlign: "end",
              marginRight: "15px",
              minWidth: "fit-content",
            }}
          >
            <ReactPlayer
              url={audioURL}
              playing={!playicon}
              ref={inputEl}
              width="0px"
              onProgress={(e) => {
                setProgresswitdh(e.played);
                // console.log(e.playedSeconds)
                if (autoscroll && e.playedSeconds > 10) {
                  const message = conversation.transcript.messages
                        .find((z) => z.startTime <= e.playedSeconds && e.playedSeconds <= z.endTime);
                    if(!message) {
                        return;
                    }
                    const place = document.getElementById(message.id);
                    if (place) {
                        if ("scrollBehavior" in document.documentElement.style) {
                            place.scrollIntoView({
                                behavior: "smooth",
                                block: "center",
                                inline: "nearest"
                            });
                        } else {
                            // Fallback for older browsers like IE11
                            scrollContainer.current.scrollTo({
                                top: (place.offsetTop - 300),
                                behavior: "smooth",
                            });
                        }
                    }
                }
              }}
              height="0px"
            />
            <CustomTooltip title={playicon ? "Play" : "Pause"}>
              <IconButton
                onClick={() => setPlayicon(!playicon)}
                aria-label={playicon ? "Play" : "Pause"}
                color="primary"
                size="small"
              >
                <FeatherIcon
                  size="48"
                  icon={playicon ? "play-circle" : "pause-circle"}
                  style={{
                    ...colours.shadowMd,
                    strokeWidth: 1,
                    borderRadius: "50%",
                  }}
                />
              </IconButton>
            </CustomTooltip>
          </div>
          <Stack
            direction="row"
            alignItems="center"
            sx={{
              minWidth: '1px',
              width: "95%",
              height: { xs: "100px", lg: "170px" },
              borderRadius: { xs: "12px", lg: "20px" },
              position: 'relative',
              overflow: "hidden",
              boxShadow:
                `inset 4px 4px 5px ${alpha(constColours.black, .15)}, inset -4px -4px 5px ${alpha(constColours.black, .15)}`,
            }}
            ref={canvref}
            onClick={() => {
              let pos = mouse.x / mouse.elementWidth;
              setPlayicon(false);
              inputEl.current.seekTo(pos);
            }}
          >
            <canvas
              id="canvas"
              width={canvswidth}
              height={150}
              ref={dref}
              style={{
                padding: "9px 0",
                position: "absolute",
                top: 0,
                left: 0,
                height: "100%",
                width: "100%",
              }}
            />
            <div
              style={{
                position: "absolute",
                width: canvswidth * progresswidth,
                height: '100%',
                background: alpha(colours.black, .25),
                top: 0,
                left: 0,
              }}
            />
          </Stack>
        </Stack>
        <Box
          display="flex"
          flexDirection="row"
          alignItems="center"
          justifyContent={{ xs: "center", sm: "space-between" }}
          flexWrap="wrap"
          sx={(theme) => ({
            background: theme.palette.mode === THEME_MODES.LIGHT ? colours.basegray : colours.white,
            position: "sticky",
            top: -25,
            left: 0,
            zIndex: 2,
            px: { xs: 1, md: 2.5 },
            py: 1,
            boxShadow: scrollPosition > 300 ? `0px 2px 4px ${alpha(constColours.black, .1)}` : 'none',
          })}
        >
          <Stack direction="row" alignItems="center">
            {scrollPosition > 300 && (
              <CustomTooltip title={playicon ? "Play" : "Pause"}>
                <IconButton
                  onClick={() => setPlayicon(!playicon)}
                  aria-label={playicon ? "Play" : "Pause"}
                  color="primary"
                  size="small"
                >
                  <FeatherIcon
                    size="48"
                    icon={playicon ? "play-circle" : "pause-circle"}
                    style={{
                      ...colours.shadowMd,
                      strokeWidth: 1,
                      borderRadius: "50%",
                    }}
                  />
                </IconButton>
              </CustomTooltip>
            )}
            <Switch
              inputProps={{ 'aria-label': autoscroll ? "Auto Scroll On" : "Auto Scroll Off" }}
              color="primary"
              value={autoscroll}
              onChange={(c) => {
                setAutoscroll(c.target.checked);
              }}
            />
            Auto Scroll
          </Stack>
          <ButtonGroup
            variant="contained"
            aria-label="outlined primary button group"
            className="buttons-border-extend"
          >
            <Button
              onClick={() => setTagsMode("trackers")}
              style={toggleButtonStyle(tagsMode === "trackers", colours, themeMode)}
            >
              Insight
            </Button>

            <Button
              onClick={() => setTagsMode("alerts")}
              style={toggleButtonStyle(tagsMode === "alerts", colours, themeMode)}
            >
              Alerts
            </Button>

            <Button
              onClick={() => setTagsMode("topics")}
              style={toggleButtonStyle(tagsMode === "topics", colours, themeMode)}
            >
              Topics
            </Button>

          </ButtonGroup>
        </Box>
        <Stack sx={{ padding: { xs: 1, md: 2.5 } }}>
          {!conversation.transcript
            ? null
            : conversation.transcript.messages
              // .filter((z) => {
              //   // z.from.name === agent;
              //   if (tsfilter === "Full") return true;
              //   else {
              //     if (
              //       tsfilter === "Agent" &&
              //       z.from.name.toUpperCase() === agent.toUpperCase()
              //     )
              //       return true;
              //     else return false;
              //   }
              // })
              .map((z, zidx) => (
                <Dbox
                  key={zidx}
                  id={z.id}
                  tagsMode={tagsMode}
                  filter={tsfilter}
                  input={{
                    id: z.id,
                    text: z.text,
                    phrases: JSON.stringify(z.phrases),
                    type: z.from.name === agent ? "agent" : "client",
                    comment: z.comment,
                    bm: z.bm,
                    alerts: trackerSet, //["empathy", "agent empathy"],
                    trackers: trackerSet,
                    topics: topicSet,
                  }}
                  output={async (c) => {
                    // console.log({ c });
                    Utils.sendProgressBar(true);
                    if (c.func === "settext") {
                      let tscr = Object.assign(
                        {},
                        conversation.transcript
                      );
                      let found = tscr.messages.find(
                        (a) => a.id === c.message
                      );
                      if (found) found.text = c.newtext;
                      await Utils.genericMutation(
                        "updateConversation",
                        {
                          id: conversation.id,
                          transcript: JSON.stringify(tscr),
                        }
                      );
                    }
                    if (c.func === "setcomment") {
                      let tscr = Object.assign(
                        {},
                        conversation.transcript
                      );
                      let found = tscr.messages.find(
                        (a) => a.id === c.message
                      );
                      if (found) found.comment = c.newtext;
                      await Utils.genericMutation(
                        "updateConversation",
                        {
                          id: conversation.id,
                          transcript: JSON.stringify(tscr),
                        }
                      );
                    }
                    if (c.func === "setbm") {
                      let tscr = Object.assign(
                        {},
                        conversation.transcript
                      );
                      let found = tscr.messages.find(
                        (a) => a.id === c.message
                      );
                      if (found) found.bm = c.bm;
                      let allbms = conversation.bookmarks;
                      if (allbms === null) allbms = [];
                      else allbms = allbms.split(",");
                      allbms = allbms.concat(c.bm);
                      allbms = [...new Set(allbms)];
                      allbms = allbms.join(",");

                      const { data } = await Utils.genericMutation(
                        "updateConversation",
                        {
                          id: conversation.id,
                          transcript: JSON.stringify(tscr),
                          bookmarks: allbms,
                        }
                      );
                      if(data?.updateConversation) {
                        const bookmarks = data.updateConversation.bookmarks || null;
                        console.log("bookmarks ", bookmarks)
                        setConversation({...conversation, bookmarks})
                      }
                    }
                    Utils.sendSnackBar(null);
                  }}
                />
              ))}
        </Stack>
      </Paper>
    </Grid>
  );
}

function Dbox({ input, output, tagsMode, id, filter }) {
  const { colours, FONT } = useThemeMode();
  function capcase(input) {
    return input.charAt(0).toUpperCase() + input.slice(1);
  }
  const [editmode, setEditmode] = useState(false);
  const [editCommentMode, setEditCommentMode] = useState(false);
  const [text, setText] = useState("");
  const [bm, setBm] = useState([]);
  const [comment, setComment] = useState("");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (event) => {
    if (typeof event === "string") changebm(event);
    setAnchorEl(null);
  };

  function changebm(val) {
    let newbm = Object.assign([], bm);
    if (bm.indexOf(val) > -1) newbm = bm.filter((z) => z !== val);
    else newbm.push(val);
    setBm(newbm);
    output({ func: "setbm", message: input.id, bm: newbm });
  }
  useEffect(() => {
    setText(input.text);
    setComment(input.comment);
    if (input.bm !== undefined) setBm(input.bm);
  }, []);

  function replacer(inputtxt, replacertxt) {
    if (!replacertxt) {
      return <div>{inputtxt}</div>;
    }

    replacertxt = JSON.parse(replacertxt);
    if (replacertxt.length === 0) return <div>{inputtxt}</div>;

    const keyword = replacertxt[0].text;
    const parts = (inputtxt + " ").split(keyword);

    return (
      <div>
        {parts.map((part, index) => (
          <React.Fragment key={index}>
            {part}
            {index < parts.length - 1 && (
              <Chip
                label={keyword}
                color="secondary"
                size="small"
                sx={(theme) => ({
                  fontSize: { xs: FONT.SIZE_14, lg: FONT.SIZE_16 },
                  p: .25,
                  height: 'inherit',
                  lineHeight: 1.25,
                  color: theme.palette.mode === THEME_MODES.DARK && colours.black,
                  '.MuiChip-label': {
                    whiteSpace: 'normal',
                  }
                })}
              />
            )}
          </React.Fragment>
        ))}
      </div>
    );
  }

  if (filter === "Full" || filter.toUpperCase() === input.type.toUpperCase())
    return (
      <Stack
        direction="row"
        alignItems="center"
        flexWrap={{ xs: "wrap", md: "nowrap" }}
        id={id}
        sx={{
          width: "100%",
          marginTop: '8px',
        }}
      >
        <Stack
          direction="row"
          flexWrap="wrap"
          sx={{
            width: { xs: "100%", md: "65%", lg: "80%" },
          }}
        >
          <Stack
            direction="row"
            flexWrap="wrap"
            alignItems="start"
            gap={1}
            sx={{
              width: "100%",
            }}
          >
            <Stack
              direction="row"
              sx={{
                width: { xs: "100%", lg: "80%" },
              }}
            >
              {/* <div style={{ minWidth: input.type === "agent" ? 0 : 60 }} /> */}
              <Box
                sx={{
                  paddingRight: 2,
                  paddingLeft: input.type === "agent" ? 0 : { xs: 5.25, lg: 7.5 },
                  flexShrink: 0,
                }}
              >
                <Avatar
                  sx={(theme) => ({
                    ...colours.shadowMd,
                    width: { xs: 30, lg: 40 },
                    minWidth: { xs: 30, lg: 40 },
                    height: { xs: 30, lg: 40 },
                    background: input.type === "agent" ? colours.black : colours.purple100,
                    borderRadius: " 22px",
                    justifyContent: "center",
                    color: (theme.palette.mode === THEME_MODES.DARK && input.type !== "agent") ? colours.black : colours.white,
                    alignItems: "center",
                    display: "flex",
                    padding: .75,
                    boxSizing: "border-box",
                  })}
                >
                  <FeatherIcon icon={input.type === "agent" ? "headphones" : "user"} />
                </Avatar>
              </Box>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Typography component="div"
                  sx={(theme) => ({
                    background: theme.palette.mode === THEME_MODES.LIGHT ? colours.white : constColours.black,
                    border: input.type === "agent" ? `1px solid ${theme.palette.mode === THEME_MODES.LIGHT ? colours.dividergray : colours.black}` : "",
                    boxSizing: "border-box",
                    boxShadow:
                      input.type === "agent"
                        ? `2px 2px 3px ${theme.palette.mode === THEME_MODES.LIGHT ? '#D1D9E6' : colours.black}, 2px 2px 3px ${theme.palette.mode === THEME_MODES.LIGHT ? colours.white : constColours.black}`
                        : "",
                    borderRadius: "0px 20px 20px 20px",
                    display: "flex",
                    flexDirection: "row",
                    minWidth: "100%",
                    padding: 1.25,
                    alignItems: "center",
                    fontSize: { xs: FONT.SIZE_14, lg: FONT.SIZE_16 }
                  })}
                >
                  {editmode ? (
                    <TextField
                      id="outlined-basic"
                      variant="outlined"
                      fullWidth={true}
                      size="small"
                      multiline={true}
                      value={text}
                      onKeyDown={(e) => {
                        if (e.keyCode === 13) {
                          output({
                            func: "settext",
                            message: input.id,
                            newtext: text,
                          });
                          setEditmode(!editmode);
                        }
                      }}
                      onChange={(c) => {
                        setText(c.target.value);
                        // console.log({ old: text, new: c.target.value });
                      }}
                    />
                  ) : (
                    <>{replacer(text, input.phrases)}</>
                  )}
                </Typography>
                {comment !== undefined || editCommentMode ? (
                  <Typography component="div"
                    sx={(theme) => ({
                      background: theme.palette.mode === THEME_MODES.LIGHT ? colours.white : constColours.black,
                      border: `1px solid ${theme.palette.mode === THEME_MODES.LIGHT ? colours.dividergray : colours.black}`,
                      boxSizing: "border-box",
                      boxShadow: `2px 2px 3px ${theme.palette.mode === THEME_MODES.LIGHT ? '#D1D9E6' : colours.black}, 2px 2px 3px ${theme.palette.mode === THEME_MODES.LIGHT ? colours.white : constColours.black}`,
                      borderRadius: "0px 20px 20px 20px",
                      display: "flex",
                      flexDirection: "row",
                      minWidth: "100%",
                      // color: colours.white,
                      padding: 1.25,
                      alignItems: "center",
                      margin: "4px 0",
                      fontSize: { xs: FONT.SIZE_14, lg: FONT.SIZE_16 }
                    })}
                  >
                    {editCommentMode ? (
                      <TextField
                        id="outlined-basic"
                        fullWidth={true}
                        size="small"
                        multiline={true}
                        label="Comment"
                        variant="outlined"
                        value={comment}
                        onKeyDown={(e) => {
                          if (e.keyCode === 13) {
                            output({
                              func: "setcomment",
                              message: input.id,
                              newtext: comment,
                            });
                            setEditCommentMode(!editCommentMode);
                          }
                        }}
                        onChange={(c) => setComment(c.target.value)}
                      />
                    ) : (
                      comment
                    )}
                  </Typography>
                ) : null}
                {bm?.length > 0 &&
                  <Stack direction="row" flexWrap="wrap" gap={.5} justifyContent="end" sx={{ margin: '8px 0' }}>
                    {bm.map((bz, bzid) => (
                      <Chip
                        label={bz}
                        key={bzid}
                        color="default"
                        avatar={
                          <FeatherIcon icon="bookmark" />
                        }
                      />
                    ))}
                  </Stack>
                }
              </div>
            </Stack>

            <Stack
              direction="row"
              alignItems="center"
              justifyContent={{ xs: "end", lg: "start" }}
              gap={.5}
              sx={{
                width: { xs: '100%', lg: 116 },
                order: { xs: '-1', lg: 'inherit' },
                position: { xs: 'relative', lg: 'static' },
                top: 0,
                right: '12px',
                marginTop: { xs: 2, lg: 1 },
                marginBottom: { xs: .5, lg: 0 },
              }}
            >
              <CustomTooltip title="Edit">
                <IconButton
                  aria-label="Edit"
                  color="primary"
                  sx={colours.shadowMd}
                  onClick={() => {
                    if (editmode)
                      output({
                        func: "settext",
                        message: input.id,
                        newtext: text,
                      });
                    setEditmode(!editmode);
                  }}
                >
                  <FeatherIcon icon="edit" size={20} />
                </IconButton>
              </CustomTooltip>
              <CustomTooltip title="Comment">
                <IconButton
                  aria-label="Comment"
                  color="primary"
                  sx={colours.shadowMd}
                  onClick={() => {
                    if (editCommentMode)
                      output({
                        func: "setcomment",
                        message: input.id,
                        newtext: comment,
                      });
                    setEditCommentMode(!editCommentMode);
                  }}
                >
                  <FeatherIcon icon="message-square" size={20} />
                </IconButton>
              </CustomTooltip>
              <div>
                <CustomTooltip title="Bookmark">
                  <IconButton
                    aria-label="Bookmark"
                    color="primary"
                    sx={colours.shadowMd}
                    id="basic-button"
                    aria-controls={open ? "basic-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                    onClick={handleClick}
                  >
                    <FeatherIcon icon="bookmark" size={20} />
                  </IconButton>
                </CustomTooltip>
                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                >
                  <MenuItem
                    onClick={() => handleClose("WOW moments")}
                  >
                    WOW moments
                  </MenuItem>
                  <MenuItem
                    onClick={() => handleClose("High risk")}
                  >
                    High risk
                  </MenuItem>
                  <MenuItem
                    onClick={() => handleClose("Great interactions")}
                  >
                    Great interactions
                  </MenuItem>
                  <MenuItem
                    onClick={() => handleClose("Poor interactions")}
                  >
                    Poor interactions
                  </MenuItem>
                  <MenuItem
                    onClick={() => handleClose("Other")}
                  >
                    Other
                  </MenuItem>
                </Menu>
              </div>
            </Stack>

          </Stack>
        </Stack>
        <Stack
          direction="row"
          flexWrap="wrap"
          sx={{
            width: { xs: "100%", md: "35%", lg: "20%" },
            paddingLeft: { xs: input.type === "agent" ? 5.25 : 10.5, md: 2, lg: 0 },
            paddingTop: { xs: 1, md: 0 },
          }}
        >
          {tagsMode === "trackers"
            ? input.trackers
              .filter((z) => z.id === input.id)
              .map((z, zidx) => (
                <Chip
                  color="default"
                  key={zidx}
                  label={capcase(removeDetectKeywordFromVisuals(z.name))}
                />
              ))
            : null}
          {tagsMode === "alerts"
            ? input.trackers
              .filter((z) => z.alert)
              .filter((z) => z.id === input.id)
              .map((z, zidx) => (
                <Chip
                  color="default"
                  key={zidx}
                  label={capcase(removeDetectKeywordFromVisuals(z.name))}
                />
              ))
            : null}
          {tagsMode === "topics"
            ? input.topics
              .filter((z) => z.id === input.id)
              .map((z, zidx) => (
                <Chip
                  color="default"
                  key={zidx}
                  label={capcase(z.name)}
                />
              ))
            : null}
        </Stack>
      </Stack>
    );
  else return null;
}

export default ConversationTranscript;